import { PARKING_RATE_ERROR,PARKING_RATE_SUCCESS,EDIT_PARKING_RATE } from './actionTypes';

const initialState = {
    error: "",
    success : ""
}

const parkingRateInfo = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_PARKING_RATE:
            state = { ...state }
            break;
        case PARKING_RATE_SUCCESS:
            state = { ...state, success: action.payload }
            break;
        case PARKING_RATE_ERROR:
            state = { ...state, error: action.payload };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default parkingRateInfo;